import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { HomeIcon, LayoutGridIcon, TagIcon, ClipboardListIcon, UserIcon, ShoppingBagIcon, XIcon, LockIcon } from 'lucide-react';
import { haptics } from '../../lib/utils/haptics';
import { useStore } from '../../lib/store';
export function MobileFooterNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const cartCount = useStore(state => state.cartCount());
  const [showPromo, setShowPromo] = React.useState(true);
  const navItems = [{
    icon: HomeIcon,
    label: 'Home',
    path: '/',
    color: 'text-gray-500',
    activeColor: 'text-[#1E2B55]'
  }, {
    icon: LayoutGridIcon,
    label: 'Categories',
    path: '/categories',
    color: 'text-gray-500',
    activeColor: 'text-[#1E2B55]'
  }, {
    icon: TagIcon,
    label: 'Offers',
    path: '/offers',
    color: 'text-gray-500',
    activeColor: 'text-[#1E2B55]'
  }, {
    icon: ClipboardListIcon,
    label: 'RX',
    path: '/rx',
    color: 'text-gray-500',
    activeColor: 'text-[#1E2B55]'
  }, {
    icon: UserIcon,
    label: 'Profile',
    path: '/account',
    color: 'text-gray-500',
    activeColor: 'text-[#1E2B55]'
  }];
  const handleNavClick = (path: string) => {
    haptics.selection();
    navigate(path);
  };
  return <>
      {/* Floating Promo Banner */}
      {showPromo && <div className="md:hidden fixed bottom-[70px] left-4 right-4 z-40" data-id="element-3076" data-mp="35j01vgnstmif">
          <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 20
      }} className="bg-white rounded-2xl shadow-lg border border-gray-100 p-3 flex items-center justify-between relative overflow-hidden" data-id="element-3077" data-mp="3j9ljz35fhsf9">
            {/* Decorative background element */}
            <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-yellow-100 to-transparent opacity-50" data-id="element-3078" data-mp="3oa9brr1hedaj"></div>
            
            <div className="flex items-center gap-3 relative z-10" data-id="element-3079" data-mp="2pwveqrsd8o6q">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-yellow-400 to-orange-500 flex items-center justify-center shadow-inner flex-shrink-0" data-id="element-3080" data-mp="2px53yd5l6rbd">
                <LockIcon className="w-5 h-5 text-white" data-id="element-3081" data-mp="2znqbiq38n66f" />
              </div>
              <div data-id="element-3082" data-mp="34mb1lwos09h5">
                <h4 className="text-sm font-bold text-gray-900 leading-tight" data-id="element-3083" data-mp="34kq7g86disjt">Cashback</h4>
                <div className="flex items-center gap-1.5 mt-0.5" data-id="element-3084" data-mp="39k339if839yj">
                  <div className="w-1.5 h-1.5 rounded-full bg-gray-300" data-id="element-3085" data-mp="3dmg7u3i8h1tq"></div>
                  <span className="text-[10px] font-medium text-gray-500 uppercase tracking-wider" data-id="element-3086" data-mp="3dkd8utz3rycv">Expires in</span>
                  <span className="text-xs font-bold text-gray-900" data-id="element-3087" data-mp="1j8gd4otmo6c0">00:52:25</span>
                </div>
              </div>
            </div>
            
            <div className="flex items-center gap-2 relative z-10" data-id="element-3088" data-mp="1o8b5kwt1x3z6">
              <button className="bg-black text-white text-xs font-bold px-4 py-2 rounded-xl active:scale-95 transition-transform" data-id="element-3089" data-mp="1goip6hwfo1av">
                Claim
              </button>
              <button onClick={() => setShowPromo(false)} className="p-1 text-gray-400 hover:text-gray-600 absolute -top-2 -right-2" data-id="element-3090" data-mp="16y76tqc05pkg">
                <XIcon className="w-4 h-4" data-id="element-3091" data-mp="11x1evuq626bz" />
              </button>
            </div>
          </motion.div>
        </div>}

      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 z-50 safe-area-bottom shadow-[0_-4px_20px_rgba(0,0,0,0.03)]" data-id="element-3092" data-mp="1uo1ja6setc46">
      <div className="flex justify-around items-center h-[60px] px-2" data-id="element-3093" data-mp="1pmvp04j3pgsj">
        {navItems.map(item => {
          const isActive = location.pathname === item.path || item.path !== '/' && location.pathname.startsWith(item.path);
          const Icon = item.icon;
          const iconColor = isActive ? item.activeColor : 'text-gray-400';
          return <button key={item.path} onClick={() => handleNavClick(item.path)} className="flex flex-col items-center justify-center gap-1 w-full h-full relative" data-id="element-3094" data-mp="1y4cscseso8i4">
              <motion.div whileTap={{
              scale: 0.9
            }} animate={isActive ? {
              scale: 1.1,
              y: -2
            } : {
              scale: 1,
              y: 0
            }} transition={{
              type: 'spring',
              stiffness: 400,
              damping: 17
            }} className="relative" data-id="element-3095" data-mp="1o7rmy5yv4vdr">
                <Icon className={`w-6 h-6 transition-colors duration-300 ${iconColor}`} strokeWidth={isActive ? 2 : 1.5} data-id="element-3096" data-mp="wehjp9t2i2p9" />
                {item.badge && <span className={`absolute -top-1.5 -right-2 ${item.badgeColor} text-white text-[10px] font-bold rounded-full min-w-[16px] h-[16px] flex items-center justify-center px-1 shadow-sm ring-2 ring-white`} data-id="element-3097" data-mp="svs4cb9u8ri4">
                    {item.badge}
                  </span>}
              </motion.div>
              <span className={`text-[10px] transition-all duration-300 tracking-tight ${isActive ? 'font-bold ' + iconColor : 'font-medium text-gray-400'}`} data-id="element-3098" data-mp="a6c2nkmf2t04">
                {item.label}
              </span>
            </button>;
        })}
      </div>
    </nav>
    </>;
}